export default __webpack_public_path__ + "static/media/T08.45424a8d.png";